import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = location.hash || window.location.hash;
    const sessionId = new URLSearchParams(hash.replace("#", "")).get("session_id");
    if (!sessionId) {
      navigate("/login");
      return;
    }
    (async () => {
      try {
        const { data } = await api.post(
          "/auth/google/session",
          {},
          { headers: { "X-Session-ID": sessionId } }
        );
        setUser(data);
        window.history.replaceState(null, "", window.location.pathname);
        const dest =
          data.role === "doctor" || data.role === "assistant"
            ? "/panel"
            : data.role === "admin"
            ? "/admin"
            : "/buscar";
        const next = sessionStorage.getItem("auth_next");
        sessionStorage.removeItem("auth_next");
        navigate(next && data.role === "patient" ? next : dest, { replace: true });
      } catch {
        navigate("/login");
      }
    })();
  }, [location, navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-slate-500 font-semibold" data-testid="auth-callback-loading">
        Iniciando sesión…
      </div>
    </div>
  );
}
